import {Divider, Form, message, Modal, Tooltip} from "antd";
import {GeneratorFilter} from "../../../../filters/Generator";
import {BillToFilter} from "../../../../filters/BillTo";
import {PaymentMethod} from "../../../../filters/PaymentMethod";
import {JobDescription} from "../../../../filters/JobDescription";
import {AddWorkOrderService} from "../extra/AddWorkOrderServiceForm";
import React from "react";
import {Config} from "../../../../controller/Global";
import {QuoteGet, QuotePost, QuoteUpdate} from "../../../../models/quote";
import TextArea from "antd/lib/input/TextArea";
import {CopyGenerator} from "../../../../controller/Utils";

const FormItem = Form.Item;

class AddUpdateWorkOrderForm extends React.Component {
  state = {
    confirmLoading: false
  };
  handlePopupAfterAddUpdate = () => {
    this.setState({ confirmLoading: false })
    this.props.fetch();
    this.props.setModelVisible()
  };
  handleUpdate = (id) => {
    const form = this.props.form;
    form.validateFields((err, values) => {
      if (!err) {
        QuoteUpdate(id, values)
          .then(response => {
            this.setState({
              visible: false,
              value: { key: response.id, label: response.name }
            });
            message.success('Quote updated successfully');
            form.resetFields();
            this.handlePopupAfterAddUpdate()
          });
      }
    });
  };
  handleCreate = (e) => {
    const form = this.props.form;
    form.validateFields((err, values) => {
      if (!err) {
        this.setState({confirmLoading: true})
        values['type'] = Config.constant.quote_type.workorder;
        QuotePost(values)   // Save Quote as well before save work order
          .then(response => {
            this.setState({
              visible: false,
              value: { key: response.id, label: response.name }
            });
            message.success('Quote created successfully');
            form.resetFields();
            this.handlePopupAfterAddUpdate();
          });
      }
    });
  };
  onRowUpdateClick = (id) => {
    const form = this.props.form;
    QuoteGet(id, {depth: 3})
      .then(response => {
        form.setFieldsValue({
          job_description: response.data.job_description
        })
        this.generator.handleChange({
          key: response.data.generator.id,
          label: `${response.data.generator.company_name} ${response.data.generator.account_number}`
        });
        this.bill_to.handleChange({
          key: response.data.bill_to.id,
          label: `${response.data.bill_to.company_name} ${response.data.bill_to.account_number}`
        });
        this.payment_term.handleChange({
          key: response.data.payment_term.id,
          label: response.data.payment_term.name
        });
        response.data.service.forEach(service => {
          this.service.handleChange(service)
        })
      });
  };
  handleDescriptionChange = (value) => {
    const form = this.props.form;
    form.setFieldsValue({
      job_description: value
    })
  };

  handleGeneratorChange = (value, bill_to=null) => {
    if(bill_to)
      this.bill_to.handleChange(bill_to);
  }

  makeCopyGenerator = () => {
    CopyGenerator(this)
  };

  componentDidUpdate(prevProps) {
    const {visible, moderated} = this.props;
    if (moderated && visible && (moderated !== prevProps.moderated || visible !== prevProps.visible))
      this.onRowUpdateClick(moderated)
  }



  render() {
    const { getFieldDecorator } = this.props.form;
    const { moderated, visible } = this.props;
    const { fields, confirmLoading } = this.state;
    return (
      <Modal title={moderated ? "Update Quote" : "Create Quote"} className="create-quote-btn" confirmLoading={confirmLoading} centered visible={visible} okText={moderated ? "Update Quote" : "Create Quote"} onOk={moderated ? () => this.handleUpdate(moderated) : this.handleCreate} onCancel={() => this.props.setModelVisible()} width="70%" destroyOnClose={true}>
        <div className="col-xs-12 paddingZ add-item-inner floating-form">
          <Form>
            <div className="row full-floating-inputs">
              <div className="col-sm-6 col-12">
                <div className="floating-label">
                  <FormItem label="Generator">
                    {getFieldDecorator('generator', {
                      rules: [{ required: true, message: 'Please select generator' }],
                    })(<GeneratorFilter onChange={this.handleGeneratorChange} onRef={ref => (this.generator = ref)} {...fields} />)}
                  </FormItem>
                </div>
                <div className="copy-data-gene">
                  <Tooltip title="Copy this generator to bill to">
                    <button onClick={() => this.makeCopyGenerator()} className="btn"><i className="fa fa-level-down" /></button>
                  </Tooltip>
                </div>
                <div className="floating-label">
                  <FormItem label="Bill To">
                    {getFieldDecorator('bill_to', {
                      rules: [{ required: true, message: 'Please select bill to' }],
                    })(<BillToFilter onRef={ref => (this.bill_to = ref)} {...fields} />)}
                  </FormItem>
                </div>
                <div className="floating-label">
                  <FormItem label="Payment Term">
                    {getFieldDecorator('payment_term', {
                      rules: [{ required: true, message: 'Please select payment term' }],
                    })(<PaymentMethod onRef={ref => (this.payment_term = ref)} {...fields} />)}
                  </FormItem>
                </div>
              </div>
              <div className="col-sm-6 col-12">
                <div className="floating-label">
                  <FormItem label="Choose Job Descriptiom">
                    {getFieldDecorator('choose_description')(<JobDescription onChange={this.handleDescriptionChange} onRef={ref => (this.choose_description = ref)} {...fields} />)}
                  </FormItem>
                </div>
                <div className="floating-label job-divider">
                  <Divider>or</Divider>
                </div>
                <div className="floating-label">
                  <FormItem label="Enter Job Descripiton">
                    {getFieldDecorator('job_description', {
                      rules: [{ required: true, message: 'Please enter job description' }],
                    })(<TextArea autosize={true} placeholder="Enter Job Description" />)}
                  </FormItem>
                </div>
              </div>
              <div className="floating-Form col-12">
                <div className="col-12 dynamic-area">
                  <div className="field-row">
                    <FormItem>
                      {getFieldDecorator('service', {
                        rules: [{ required: true, message: 'Please select service' }],
                      })(<AddWorkOrderService onRef={ref => (this.service = ref)} {...fields} />)}
                    </FormItem>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Modal>
    )
  }
}

export const AddUpdateWorkOrder = Form.create()(AddUpdateWorkOrderForm);



// WEBPACK FOOTER //
// ./src/pages/tracks/quotes/popups/AddUpdateWorkOrder.jsx